import axios from "axios";
import { API_BASE_URL } from "../../config";

const BASE = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

/**
 * Fetch the Trial Balance report.
 * @param {Object} filters - { start_date, end_date }
 */
export const getTrialBalance = async (filters = {}) => {
  const params = Object.fromEntries(
    Object.entries(filters).filter(([, v]) => v !== "" && v !== null && v !== undefined)
  );
  const response = await axios.get(`${BASE}/reports/trial-balance`, { params });
  return response.data;
};
